import React from "react";
import classNames from "classnames";
import { LabelCustomCSS } from "./label-helper";

interface LabelProps extends React.HtmlHTMLAttributes<HTMLLabelElement> {
  /**
   * Spacing bottom
   */
  spacingBottom?: number;
  /**
   * Required
   */
  required?: boolean;
  /**
   * Extend classnames
   */
  extendClasses?: string;
}

const Label: React.FC<LabelProps> = ({
  spacingBottom = 4,
  extendClasses,
  required,
  children,
  ...props
}) => (
  <label
    className={classNames({
      tfcLabel: true,
      ["tfcLabel-required"]: required,
      [extendClasses as string]: !!extendClasses,
    })}
    style={
      {
        "--spacing-bottom": `${spacingBottom}px`,
      } as LabelCustomCSS
    }
    {...props}
  >
    {children}
  </label>
);

export default Label;
